import { ComparisonOperators } from '@contentsquare/fov-constants';
import { FovPageType } from '@contentsquare/fov-constants';
export const textSeenCondition = {
    id: 'text-seen',
    category: 'conditions',
    value: {
        operatorValues: [
            {
                value: ComparisonOperators.MATCH_REGEX,
                label: 'CONDITION_DETAILS_TEXT_SEEN_PART_2',
            },
            {
                value: ComparisonOperators.DOES_NOT_MATCH_REGEX,
                label: 'CONDITION_DETAILS_TEXT_SEEN_PART_3',
            },
        ],
        pageTypes: [
            {
                value: FovPageType.ANY,
                label: 'CONDITION_SELECT_ANY_PAGE',
            },
            {
                value: FovPageType.PAGE,
                label: 'CONDITION_SELECT_SPECIFIC_PAGE',
            },
            {
                value: FovPageType.URL,
                label: 'CONDITION_SELECT_SPECIFIC_URL',
            },
        ],
    },
};
//# sourceMappingURL=text-seen-condition.value.js.map